import UserStreamBox from './UserStreamBox';
import UserStreamBoxWide from './UserStreamBoxWide';
import { containerCreator } from './UserStream.container';
import {
  WATCHER_IDS_STREAM,
  GROUP_MEMBERS_IDS_STREAM,
  GROUP_NEWEST_MEMBERS_IDS_STREAM,
  GROUP_ACTIVE_MEMBERS_IDS_STREAM,
} from '../../../streams';
import { ModuleType } from '../../../../types/modules';

const WatchersBox = containerCreator(
  ModuleType.WATCHERS,
  WATCHER_IDS_STREAM
)(UserStreamBox);

const WatchersBoxWide = containerCreator(
  ModuleType.WATCHERS,
  WATCHER_IDS_STREAM
)(UserStreamBoxWide);

const MembersBox = containerCreator(
  ModuleType.GROUP_MEMBERS,
  GROUP_MEMBERS_IDS_STREAM
)(UserStreamBox);

const MembersBoxWide = containerCreator(
  ModuleType.GROUP_MEMBERS,
  GROUP_MEMBERS_IDS_STREAM
)(UserStreamBoxWide);

const ActiveMembersBox = containerCreator(
  ModuleType.ACTIVE_MEMBERS,
  GROUP_ACTIVE_MEMBERS_IDS_STREAM
)(UserStreamBox);

const ActiveMembersBoxWide = containerCreator(
  ModuleType.ACTIVE_MEMBERS,
  GROUP_ACTIVE_MEMBERS_IDS_STREAM
)(UserStreamBoxWide);

const NewestMembersBox = containerCreator(
  ModuleType.NEWEST_MEMBERS,
  GROUP_NEWEST_MEMBERS_IDS_STREAM
)(UserStreamBox);

const NewestMembersBoxWide = containerCreator(
  ModuleType.NEWEST_MEMBERS,
  GROUP_NEWEST_MEMBERS_IDS_STREAM
)(UserStreamBoxWide);
export {
  WatchersBox,
  WatchersBoxWide,
  MembersBox,
  MembersBoxWide,
  ActiveMembersBox,
  ActiveMembersBoxWide,
  NewestMembersBox,
  NewestMembersBoxWide,
};
